export default function (html) {
  if (!html) return ''
  let tmp = document.implementation.createHTMLDocument('New').body
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}
